import { memo } from 'react'
import { Skeleton } from '../Skeleton'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean
  // Shows a pulsing placeholder in the input's shape while its value loads
  skeleton?: boolean
  ref?: React.Ref<HTMLInputElement>
}

export const Input = memo(({ error, skeleton, className, ...rest }: InputProps) => {
  if (skeleton) {
    return <Skeleton shape="input" />
  }
  const classes = ['form-control', error ? 'form-control--error' : '', className ?? '']
    .filter(Boolean)
    .join(' ')
  return <input className={classes} {...rest} />
})

Input.displayName = 'Input'
